<template>
  <div class="pay-ops">

    <div class="titulo">
      <h1>Quero pagar uma conta</h1>
    </div>

    <div class="card-box full">
      <p>
        O Padmoney é um sistema de gestão de pagamentos online. Nosso sistema é destinado a pessoas
        ou empresas que desejam realizar suas cobranças de prestação de serviços ou venda de
        produtos de forma prática e segura.
      </p>
      <p>
        Se você está acessando o Padmoney com o objetivo de efetuar o pagamento de alguma conta ou
        retirar uma segunda via de boleto bancário, pedimos que entre em contato diretamente com a
        empresa ou pessoa que tenha comprado ou utilizado o serviço para que sua solicitação seja
        devidamente atendida.
      </p>
      <p>
        Mas se porventura você deseja utilizar nosso sistema para receber de seus clientes,
        automatizando a gestão de suas cobranças online, basta clicar no botão abaixo “Ok, entendi”
        e retornar à tela anterior e então clicar em “Quero cobrar meus clientes” e seguir os
        passos para se cadastrar em nosso sistema.
      </p>
      <p>
        Seja qual for o seu negócio, o Padmoney é a solução perfeita para você!
      </p>
      <div class="btn-section">
        <button class="botao azul" @click="$emit('back')">
          Ok, entendi
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Info from '@/components/Info'

export default {
  name: 'PayOps',
  components: { Info }
}
</script>
